/*
 * Copyright (C) 2005 - 2022 TIBCO Software Inc. All rights reserved. Confidentiality & Proprietary.
 * Licensed pursuant to commercial TIBCO End User License Agreement.
 */

import { useSelector } from 'react-redux';
import { IState, VisualizeEvent } from '../store/types/StateTypes';

interface IValueSetter {
    set: (name: string, value: any) => void
}

export default function EventComponent({ stateModel } : {stateModel: IValueSetter}) {
    const event = useSelector<IState, VisualizeEvent | undefined>((state) => state.lastEvent);

    if (event) {
        stateModel.set(`_${event.name}`, event.payload);
    }

    return null;
}
